
export const SystemEvent = {
  /**
   * When any of the `SystemOption` is clicked from a `SystemListMessage`.
   * @see SystemOption
   * @see SystemListMessage
   */
  LIST_OPTION_SELECTED: 'sys:option:selected',
  /**
   * When the user clicks yes no from a response message.
   */
  USER_RESOLUTION_SELECTED: 'sys:resolution:selected',
  /**
   * When an article with preview is expanded.
   */
  ARTICLE_PREVIEW_EXPANDED: 'sys:article:expanded',
  /**
   * If none of the above is visible and selected, then this event is emitted.
   */
  NONE_OF_THE_ABOVE_SELECTED: 'sys:option:noneOfTheAbove',
  /**
   * When the user clicks an interactive message that can be rolled back.
   */
  USER_ROLLBACK: 'sys:rollback',
  /**
   * User has selected an action to execute.
   */
  ACTION_SELECTED: 'user:action',
  /**
   * Event selected to browser other articles.
   */
  ARTICLE_LIST_NAVIGATION: 'sys:selection:articleList:navigation',
  /**
   * Event fired when a predefined option is selected.
   */
  PRE_SUPPORT_SELECTION: 'sys:selection:preSupport',
  /**
   * When the user clicks an alternative action.
   */
  ALTERNATIVE_ACTION: 'sys:selection:alternativeAction',
  /**
   * A selection event from the predictive option. If the end user selects,
   * Need more help or not.
   */
  PREDICTIVE_SUGGESTION_SELECTION: 'sys:predictive_suggestion:selection',
  /**
   * When we got a response from the AI.
   */
  RESPONSE_FROM_AI: 'sys:response:fromAi',

  /**
   * When the user rates the AI response.
   */
  RATE_AI_RESPONSE: 'sys:rateAiResponse',
} as const;
